import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reset: {
    defaultMessage: 'Reset',
    description: 'Restore a field to its original value',
  },
  editHiringGoal: {
    defaultMessage: 'Edit hiring goal',
    description: 'Open the hiring target in Hire to change it',
  },
  active: {
    defaultMessage: 'Active',
    description: 'An opening currently accepting applicants',
  },
  inactive: {
    defaultMessage: 'Inactive',
    description: 'An opening not currently accepting applicants',
  },
  information: {
    defaultMessage: 'Information',
    description:
      'Accessible name for an icon that reveals additional explanation',
  },
  fundsLocked: {
    defaultMessage: 'Funds locked',
    description: 'Campaign funds committed upfront that cannot be reallocated',
  },
  endingSoon: {
    defaultMessage: 'Hiring goal ending soon',
    description: 'Warning that the hiring target end date is approaching',
  },
  toggleSidebar: {
    defaultMessage: 'Toggle sidebar',
    description: 'Expand or collapse the navigation sidebar',
  },
  clearDate: {
    defaultMessage: 'Clear date',
    description: 'Remove the selected calendar date from a field',
  },
});
